import React, { useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link, useParams } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";
import { getProducts } from "../helpers/Products";
import { show, update } from "../helpers/Series";
import { useForm } from "react-hook-form";
import Loading from "../components/Loading";
import AddAmazon from "../components/AddAmazon";
import Input from "../components/Input";
import { Tabs } from "../frontend/components/Tabs";
import { search } from "../helpers/Attributes";


export default function SeriesPage() {
    const { appState } = useAppState();
    const { id } = useParams();
    const { register, handleSubmit } = useForm();
    const [products, setProducts] = useState<any[]>([])
    const [newAdded, setNewAdded] = useState<any>({})
    const [search, setSearch] = useState<string | null>(null)

    const [seriesItem, setSeriesItem] = useState<any>(null)
    const abortController = useRef<AbortController>();

    const [attributeValues, setAttributeValues] = useState<any>([]);

    const handleSearch = (event) => {
        setSearch(event.target.value)
    }

    const handleAddNew = (product) => {
        setNewAdded((prev) => {
            return {
                ...prev,
                [product.id]: {
                    name: product.name,
                    variantValue: '',
                }
            }
        })
    }

    const updateAddNewVariantValue = (id, value) => {
        setNewAdded((prev) => {
            return {
                ...prev,
                [id]: {
                    ...prev[id],
                    variantValue: value,
                }
            }
        })
    }

    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort()
        }
        abortController.current = new AbortController();

        if (search === '' || search === null) {
            setProducts([]);
            return;
        }

        getProducts(50, 1, {
            search,
            inStock: false
        }, { signal: abortController.current.signal }).then((result) => {
            setProducts(result.data)
        })
    }, [search])

    useEffect(() => {
        if (id) {
            show(parseInt(id)).then((result) => {
                setSeriesItem(result)
            })
        }
    }, [id])

    const onSubmit = handleSubmit((values) => {
        console.log(newAdded)

        const newObj = {};

        Object.keys(newAdded).forEach((id) => {
            newObj[id] = newAdded[id].variantValue;
        })

        console.log(newObj)

        update(seriesItem.id, { new: newObj })
    });


    if (seriesItem === null) {
        return <Loading />;
    }

    return (
        <>
            <form onSubmit={onSubmit} className="mb-20">
                <div className="flex justify-between items-center">
                    <div className="">
                        <h1 className="text-xl">{seriesItem.name}</h1>
                    </div>
                </div>
                <div className="mt-3 p-6 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Details</h3>
                    <div className="flex flex-col gap-y-2">
                        <div className="flex flex-col">
                            <label>Name</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('name')}
                                defaultValue={seriesItem.name}
                                placeholder="Name"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label>Variant type</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('variantType')}
                                defaultValue={seriesItem.variantType}
                                placeholder="Variant type"
                            />
                        </div>
                    </div>
                </div>

                <div className="mt-3 p-6 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Products</h3>
                    <div className="flex flex-between gap-x-2">
                        <div className="flex flex-1 w-1/2 flex-col gap-y-2">
                            <div>
                                <input className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Search product" onChange={handleSearch}></input>
                            </div>
                            <div>
                                Products
                            </div>
                            <div>
                                {products.map((product) => {
                                    return (<div>
                                        <div>{product.name}</div>
                                        <button type="button" onClick={() => { handleAddNew(product) }}>add</button>
                                    </div>)
                                })}
                            </div>
                        </div>
                        <div className="border-r-1 w-0.5"></div>
                        <div className="flex flex-1 w-1/2 flex-col gap-y-2">
                            {Object.keys(newAdded).length > 0 ? (
                                <>
                                    <div>New added:</div>
                                    {Object.keys(newAdded).map((productId) => {
                                        const product = newAdded[productId];
                                        return (<div>
                                            <div>{product.name}</div>
                                            <input onChange={({ target }) => { updateAddNewVariantValue(productId, target.value) }} className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Variant value" />
                                        </div>)
                                    })}
                                </>
                            ) : null}

                            <div>Included products:</div>
                            {seriesItem.productSeries.map((item) => {
                                return (<div>
                                    <div>{item.product.name}</div>
                                    <input className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" placeholder="Variant value" defaultValue={item.variant_value} />
                                </div>)
                            })}

                        </div>
                    </div>
                </div>

                <div className="fixed bottom-0 left-0 right-0 z-40 p-6 border-t border-gray-100 bg-white/75">
                    <div className="flex gap-2 justify-end">
                        <button
                            className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            type="submit"
                        >
                            Save
                        </button>
                    </div>

                </div>
            </form>

        </>
    );
}
